import axios from "axios";
import { logout } from "./Utils";
import { HttpStatusCode } from "./Constants";
import { toast } from "react-toastify";

const notifyError = (message: string) => toast.error(message);

const token = localStorage.getItem("access_token");
let axiosConfig = {};
if (token) {
  axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

const request = axios.create(axiosConfig);

request.interceptors.response.use(
  (response) => response,
  (error) => {
    switch (error.response.status) {
      case HttpStatusCode.Unauthorized:
      case HttpStatusCode.UnprocessableEntity:
        logout();
        break;
      case HttpStatusCode.Forbidden:
        if (error.config.url && error.config.url === "/api/auth/login")
          notifyError(error.response.data.message);
        else {
          window.location.href = "/login";
        }
        break;

        case HttpStatusCode.BadRequest:
        case HttpStatusCode.InternalServerError:
        case HttpStatusCode.NotFound:
        case HttpStatusCode.RequestTimeout:
        case HttpStatusCode.NotImplemented:
          notifyError(error.response.data.message);
          break;
      default:
        break;
    }
  }
);
export default request;
